/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const TrashOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M20.25 6H3.75m6 4.5v6m4.5-6v6M18.75 6v14.25c0 .2-.08.39-.22.53A.71.71 0 0 1 18 21H6a.71.71 0 0 1-.53-.22.75.75 0 0 1-.22-.53V6m10.5 0V4.5a1.499 1.499 0 0 0-1.5-1.5h-4.5a1.499 1.499 0 0 0-1.5 1.5V6"
})); // Fill


const TrashFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M20.25 5.25H16.5V4.5c0-.59-.24-1.16-.66-1.58-.42-.43-.99-.66-1.59-.67h-4.5c-.6.01-1.17.24-1.59.67-.42.42-.66.99-.66 1.58v.75H3.75a.75.75 0 0 0-.53 1.28c.14.15.33.22.53.22h.75v13.5c0 .4.16.78.44 1.06.28.29.66.44 1.06.44h12c.4 0 .78-.15 1.06-.44.28-.28.44-.66.44-1.06V6.75h.75c.2 0 .39-.07.53-.22a.75.75 0 0 0-.53-1.28zM10.5 16.5c0 .2-.08.39-.22.53-.14.15-.33.22-.53.22s-.39-.07-.53-.22A.75.75 0 0 1 9 16.5v-6a.75.75 0 1 1 1.5 0v6zm4.5 0c0 .2-.08.39-.22.53-.14.15-.33.22-.53.22s-.39-.07-.53-.22a.75.75 0 0 1-.22-.53v-6a.75.75 0 1 1 1.5 0v6zm0-11.25H9V4.5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v.75z"
})); // DuoTone


const TrashDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M18.75 6v14.25c0 .2-.08.39-.22.53A.71.71 0 0 1 18 21H6a.71.71 0 0 1-.53-.22.75.75 0 0 1-.22-.53V6h13.5z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M20.25 6H3.75m6 4.5v6m4.5-6v6M18.75 6v14.25c0 .2-.08.39-.22.53A.71.71 0 0 1 18 21H6a.71.71 0 0 1-.53-.22.75.75 0 0 1-.22-.53V6m10.5 0V4.5a1.499 1.499 0 0 0-1.5-1.5h-4.5a1.499 1.499 0 0 0-1.5 1.5V6"
}));
/**
  Icon TrashIcon in office group
*/


export const TrashIcon = createIcon('TrashIcon', 'trash', 'office', TrashOutline, TrashFill, TrashDuotone, "0 0 24 24");